import { render } from "./ListDetailView.vue?vue&type=template&id=2e9b6f4b&scoped=true"
import script from "./ListDetailView.vue?vue&type=script&lang=js"
export * from "./ListDetailView.vue?vue&type=script&lang=js"

import "./ListDetailView.vue?vue&type=style&index=0&id=2e9b6f4b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9b6f4b"]])

export default __exports__